import routes from '../routes';

const STORAGE_KEY = 'postLoginRedirect';

const BLOCKED_PREFIXES = [
  routes.LoginPage,
  routes.GoogleCallbackPage,
  routes.MicrosoftCallbackPage,
  routes.SetPasswordPage,
];

export function isSafePostLoginPath(path) {
  if (typeof path !== 'string' || path.length === 0) return false;
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.includes('\\') || path.includes('://')) return false;

  const pathname = path.split(/[?#]/)[0];
  return !BLOCKED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function rememberPostLoginPath(location) {
  if (typeof window === 'undefined' || !location?.pathname) return;

  const path = `${location.pathname}${location.search || ''}${location.hash || ''}`;
  if (!isSafePostLoginPath(path)) return;

  sessionStorage.setItem(STORAGE_KEY, path);
}

export function consumePostLoginPath() {
  if (typeof window === 'undefined') return routes.HomePage;

  const stored = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);

  return isSafePostLoginPath(stored) ? stored : routes.HomePage;
}
